"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckpointConditionFailed = exports.CheckpointCondition = exports.CheckpointKeys = exports.RelativeTimingType = void 0;
var RelativeTimingType;
(function (RelativeTimingType) {
    RelativeTimingType["CREATED_AT"] = "CREATED_AT";
    RelativeTimingType["FIRST_MIDNIGHT"] = "FIRST_MIDNIGHT";
})(RelativeTimingType = exports.RelativeTimingType || (exports.RelativeTimingType = {}));
var CheckpointKeys;
(function (CheckpointKeys) {
    CheckpointKeys["FOLLOW"] = "FOLLOW";
    CheckpointKeys["LIKE_A_POST"] = "LIKE_A_POST";
    CheckpointKeys["RECOMMEND_USER"] = "RECOMMEND_USER";
    CheckpointKeys["RECOMMEND_CLUB"] = "RECOMMEND_CLUB";
    CheckpointKeys["RECOMMEND_EVENT"] = "RECOMMEND_EVENT";
    CheckpointKeys["CUSTOM_MESSAGE"] = "CUSTOM_MESSAGE";
})(CheckpointKeys = exports.CheckpointKeys || (exports.CheckpointKeys = {}));
var CheckpointCondition;
(function (CheckpointCondition) {
    CheckpointCondition["ALWAYS"] = "ALWAYS";
    CheckpointCondition["NO_BIKE"] = "NO_BIKE";
    CheckpointCondition["NO_POST"] = "NO_POST";
    CheckpointCondition["NO_CLUB_MEMBERSHIP"] = "NO_CLUB_MEMBERSHIP";
    CheckpointCondition["NO_EVENT_RSVPS"] = "NO_EVENT_RSVPS";
    CheckpointCondition["NO_LOCATION"] = "NO_LOCATION";
    CheckpointCondition["NO_AVATAR"] = "NO_AVATAR";
    CheckpointCondition["NO_ACTIVITIES"] = "NO_ACTIVITIES";
    CheckpointCondition["HAS_BIKE"] = "HAS_BIKE";
    CheckpointCondition["HAS_POST"] = "HAS_POST";
    CheckpointCondition["HAS_CLUB_MEMBERSHIP"] = "HAS_CLUB_MEMBERSHIP";
    CheckpointCondition["HAS_EVENT_RSVPS"] = "HAS_EVENT_RSVPS";
    CheckpointCondition["HAS_LOCATION"] = "HAS_LOCATION";
    CheckpointCondition["HAS_AVATAR"] = "HAS_AVATAR";
    CheckpointCondition["HAS_ACTIVITIES"] = "HAS_ACTIVITIES";
})(CheckpointCondition = exports.CheckpointCondition || (exports.CheckpointCondition = {}));
var CheckpointConditionFailed;
(function (CheckpointConditionFailed) {
    CheckpointConditionFailed["progress"] = "progress";
    CheckpointConditionFailed["wait"] = "wait";
})(CheckpointConditionFailed = exports.CheckpointConditionFailed || (exports.CheckpointConditionFailed = {}));
